import React from "react";
import classNames from "classnames";
import Select from "../../components/Select";
import InfoButton from "./InfoButton";

export default function (props) {
  const className = props.className;

  return (
    <div className={classNames("form-item", { [className]: !!className })}>
      <div className="form-item__label">
        {props.info && <InfoButton marginBottom={10}>{props.info}</InfoButton>}
        <p className="form-item__title">{props.title}</p>
      </div>
      <div className="form-item__field">
        <Select
          className="sb-select"
          current={props.value.value}
          name={props.name}
          setValue={props.setValue}
        >
          {props.items.map((item) => (
            <Select.Item item={item} key={item.id} />
          ))}
        </Select>
      </div>
    </div>
  );
}
